import { useContext } from "react";
import CrewContext from "../context/CrewContext";

const useCrew = () => useContext(CrewContext);

export default useCrew;
